export default "__VITE_ASSET__BXv8L2P3__"